module.exports = __webpack_public_path__ + "media/images/link-44dfb1f44ea27d71ecf4ca4c92175c75.svg";